var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 790 88",
    style: {
      enableBackground: "new 0 0 790 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3E87BB;}\n\t.st1{fill:#2E7DB5;}\n\t.st2{opacity:0.5;fill:#0B65A7;}\n\t.st3{fill:#004F9B;}\n\t.st4{opacity:0.7;fill:#0B65A7;}\n\t.st5{fill:#00308A;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 790,
    height: 88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.7,52.6c21.8,6.8,45.7,11.7,68.1,16.6c17.3,3.9,34.9,9.3,49.4,18.8H790V0H472.7 C489.8,21.6,514.9,41.2,551.7,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M790,1.5L784.4,0H493.2c8.3,7.7,18.3,14.2,29.3,18.7c17.5,7.2,36.8,9.5,55.2,14.8 c29.1,8.3,55.8,24.2,75.7,44.9c3,3.1,5.8,6.3,8.5,9.6H790V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M527.4,6.5c42.3,6.3,87.1-1.2,123,27.6c12.6,10.1,24.5,21.7,38.7,29.7c24,13.4,54.4,16.6,83.3,20.4 c5.8,0.8,11.7,1.6,17.6,2.7V0H505.8C512.3,3,519.5,5.3,527.4,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M605.5,28.1c24.2,22.7,54.3,30.7,90.5,24.7c12-2,64.7-18.4,77.1-19.1c6.5-0.4,12.1,0.5,16.9,2.2V0H576.3 C586,9.4,595.6,18.8,605.5,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M678.7,41.1c30.8,20.3,71.9,26.7,110.8,26.3c0.2,0,0.3,0,0.5,0V0H633.3C647.8,14.1,661.3,29.6,678.7,41.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBackground);
export default __webpack_public_path__ + "static/media/bannerBackground.387c584779b0a44f795feff0578ddde3.svg";
export { ForwardRef as ReactComponent };